export default __webpack_public_path__ + "assets/078c1cbe21db7c81bcbcca55cc1925ad.png";